import React, { useState, useRef, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { TablaResultados } from './TablaResultados';
import { ServicioObjetos } from '../../../servicios/ServicioObjetos';
import { ServicioFormatos } from '../../../servicios/ServicioFormatos';
import { ServicioHttp } from '../../../servicios/ServicioHttp';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR, DEFAULT_MASKS } from '../../../servicios/Constantes';
const PAGINACION_INICIAL = {
    registrosPorPagina: 20,
    numeroPagina: 0,
    restriccionesDinamicas: [],
    datos: [],
    join: {}
};

export const ConsultaUsuario = () => {

    const [busqueda, setBusqueda] = useState({});
    const [errores, setErrores] = useState({});
    const [paginacion, setPaginacion] = useState(PAGINACION_INICIAL);
    const toast = useRef(null);

    const handleChange = e => {
        const { name, value } = e.target;
        console.log(name);
        console.log(value);
        setBusqueda(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: value
        }));
        
    };
    const asignarRestricciones = () => {
        paginacion.restriccionesDinamicas = [];

       

       
       
       
        if (!ServicioObjetos.esObjetoVacio(busqueda.usuario)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'usuario',
                valorPropiedad: busqueda.usuario,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }
        

       
        paginacion.join = { "tcPerfil": "alias_tcPerfil" };

        setPaginacion(paginacion);
    }

    const funcionPaginacion = (laPaginacion) => {
        setPaginacion(laPaginacion);
        paginar();
    }

    const paginar = () => {
        asignarRestricciones();
        ServicioHttp.consumirPostHttp('consulta/usuario.json', paginacion).then(response => {
            setPaginacion(response.data.objeto);
            toast.current.show({ severity: response.data.error === false ? "success" : "error", summary: '', detail: response.data.mensaje, life: 8000 });
        }).catch(error => {
            setPaginacion(paginacion);
            toast.current.show({ severity: 'error', summary: '', detail: "Error de conexion al servidor", life: 8000 });
        });
    }

    const buscar = () => {
        paginacion.numeroPagina = 0;
            paginar();
        
    }

    return (
        <div>
             <Toast ref={toast} />
             <div className="grid">
             <div className="col-12">
             <div className="card">
                        <h5>Administración de Usuarios</h5>
                        <p>En esta sección usted podra ver los Usuarios registrados en el portal</p>
                    </div>
                    <div className="card">
                        <h5>Para realizar la búsqueda elije uno o varios criterios</h5>
                        
                        <div className="p-fluid formgrid grid">
                        <div className="field col-12 md:col-6">
                                <label htmlFor="usuario">Usuario:</label>
                                <InputText id="usuario" type="text" name="usuario"
                                    value={busqueda.usuario || ""} onChange={handleChange} />
                            </div>
                            
                           
                            
                            <div className="col-12 md:col-3">
                                <Button label="Buscar" icon="pi pi-search" onClick={buscar} />
                            </div>
                            </div>
                        </div>
                 </div>
             </div>
             <TablaResultados paginacion={paginacion} funcionPaginacion={funcionPaginacion} toast={toast} asignarRestricciones={asignarRestricciones} />
            </div>
        );
}
